import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLoading } from '../components/LoadingProvider';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsAuthenticated, selectCurrentUser, selectCurrentUserRole, logout } from '../store/slices/authSlice';
import api from '../api/axios';
import { getPublicImgUrl } from '../utils/common';

export default function Header() {
    const { setIsLoading } = useLoading();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const currentUser = useSelector(selectCurrentUser);
    const currentUserRole = useSelector(selectCurrentUserRole);

    const [showAuthContent, setShowAuthContent] = useState(false);
    useEffect(() => {
        setShowAuthContent(isAuthenticated);
    }, [isAuthenticated]);

    const [showMobNavbar, setShowMobNavbar] = useState(false);
    const handleNavbar = (e) => {
        setShowMobNavbar(!showMobNavbar);
    };

    const [showUserNavbar, setShowUserNavbar] = useState(false);
    const handleUserNavbar = (e) => {
        setShowUserNavbar(!showUserNavbar);
    };

    const closeNavbars = (e) => {
        setShowUserNavbar(false);
        setShowMobNavbar(false);
    };

    // Handle logout function
    const handleLogout = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await api.post(`/${currentUserRole}/logout`);
            dispatch(logout());
            setShowAuthContent(false);
            navigate('/login');
        } catch (error) {
            dispatch(error.response?.data?.message || 'Failed to Logout. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    let navLinks = [
        { href: '/', label: 'Home' },
        { href: '/aboutus', label: 'About' },
        { href: '/#findDoctor', label: 'Find a Doctor' },
        { href: '/contactus', label: 'Contact Us' },
    ];

    const patientNavLinks = [
        { href: `/dashboard/patient`, label: 'Home' },
        { href: '/aboutus', label: 'About' },
        { href: `/doctorlist`, label: 'Doctor List' },
        { href: '/contactus', label: 'Contact Us' },
        // { action: handleLogout, label: 'Logout' },
    ];

    const doctorNavLinks = [
        { href: `/dashboard/doctor`, label: 'Home' },
        { href: `/dashboard/doctor/appointments`, label: 'Appointments' },
        { href: `/dashboard/doctor/appointment-slots`, label: 'Slots' },
        { href: `/dashboard/doctor/reports`, label: 'Reports' },
        // { action: handleLogout, label: 'Logout' },
    ];

    const clinicNavLinks = [
        { href: `/dashboard/clinic`, label: 'Home' },
        { href: `/dashboard/clinic/appointments`, label: 'Appointments' },
        { href: '/aboutus', label: 'About' },
        { href: `/doctorlist`, label: 'Doctor List' },
        // { href: '/contactus', label: 'Contact Us' },
        // { action: handleLogout, label: 'Logout' },
    ];

    const hospitalNavLinks = [
        { href: `/dashboard/hospital`, label: 'Home' },
        { href: `/dashboard/hospital/profile`, label: 'Profile' },
        { href: '/aboutus', label: 'About' },
        { href: `/doctorlist`, label: 'Doctor List' },
    ];

    const userNavLinks = [
        { href: `/dashboard/${currentUserRole}`, label: 'Home' },
        { href: `/dashboard/${currentUserRole}/appointment`, label: 'Appointments' },
        { href: `/dashboard/${currentUserRole}/profile`, label: 'Profile' },
        { action: handleLogout, label: 'Logout' },
    ];

    if(currentUserRole === 'patient'){
        navLinks = patientNavLinks;
    }else if(currentUserRole === 'doctor'){
        navLinks = doctorNavLinks;
    }else if(currentUserRole === 'clinic'){
        navLinks = clinicNavLinks;
    }else if(currentUserRole === 'hospital'){
        navLinks = hospitalNavLinks;
    }

    return (
        <>
            <div className="container-fluid bg-dark px-5 d-none d-lg-block">
                <div className="row gx-0 align-items-center" style={{height: '45px'}}>
                    <div className="col-lg-8 text-center text-lg-start mb-lg-0">
                        <div className="d-flex flex-wrap">
                            <a href="tel:+91 8240112175" className="text-light me-4"><i className="fas fa-phone-alt text-primary me-2"></i>+91 8240112175</a>
                            <a href="mailto:varosahealth@gmail.com" className="text-light me-0"><i className="fas fa-envelope text-primary me-2"></i>  varosahealth@gmail.com</a>
                        </div>
                    </div>
                    <div className="col-lg-4 text-center text-lg-end">
                        <div className="d-flex align-items-center justify-content-end">
                            <a href="https://play.google.com/store/apps/details?id=com.varosa.patient" className="btn btn-light btn-square border rounded-circle nav-fill me-3" target="_blank" rel="noopener noreferrer"><i className="fab fa-google-play"></i></a>
                            {/* <a href="#" className="btn btn-light btn-square border rounded-circle nav-fill me-3"><i className="fab fa-facebook-f"></i></a>
                            <a href="#" className="btn btn-light btn-square border rounded-circle nav-fill me-3"><i className="fab fa-twitter"></i></a>
                            <a href="#" className="btn btn-light btn-square border rounded-circle nav-fill me-3"><i className="fab fa-instagram"></i></a>
                            <a href="#" className="btn btn-light btn-square border rounded-circle nav-fill me-0"><i className="fab fa-linkedin-in"></i></a> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid position-relative p-0">
                <nav className="navbar navbar-expand-lg navbar-light bg-white px-4 px-lg-5 py-3 py-lg-2">
                    <Link to={navLinks[0].href} className="" onClick={closeNavbars}>
                        <h1 className="text-primary m-0"><img src={getPublicImgUrl()+"/VAROSA.png"} width={114} height={78} alt="Logo" /></h1>
                    </Link>
                    <div>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" onClick={handleNavbar}>
                            <span className="fa fa-bars"></span>
                        </button>
                    </div>
                    <div className={`collapse navbar-collapse ${showMobNavbar ? 'show' : ''}`} id="navbarCollapse">
                        <div className="navbar-nav ms-auto py-0">
                            {navLinks.map((link) => (
                                link.href ? (<Link
                                    key={link.href} 
                                    to={link.href}
                                    className={`nav-item nav-link ${location.pathname === link.href ? 'active' : ''}`}
                                    onClick={closeNavbars}
                                >
                                    {link.label}
                                </Link>) : (
                                    <a 
                                        key={link.href}
                                        href="#" 
                                        className="nav-item nav-link"
                                        onClick={(e) => { closeNavbars(e); link.action(e); }}
                                    >
                                        {link.label === 'Logout' ? <button className="btn btn-primary rounded-pill text-white py-2 px-4 flex-wrap flex-sm-shrink-0" onClick={handleLogout}><i className="bi bi-box-arrow-right" style={{ fontSize: '20px' }}></i></button> : link.label}
                                    </a>
                                )
                            ))}
                        </div>
                        {showAuthContent ? (
                            <>
                                {currentUserRole === 'patient' && <Link to="/dashboard/patient/appointment/book" 
                                    className="btn btn-primary rounded-pill text-white py-2 px-4 flex-wrap flex-sm-shrink-0 mr-2 mt-1" 
                                    onClick={(e) => { closeNavbars(e); }}
                                    style={{ marginRight: '7px' }}
                                >Book Appointment</Link>}
                                <Link to={`/dashboard/${currentUserRole}/profile`} 
                                    className="btn btn-primary rounded-pill text-white py-2 px-4 flex-wrap flex-sm-shrink-0 mr-2 mt-1" 
                                    onClick={(e) => { closeNavbars(e); }}
                                    style={{ marginRight: '7px' }}
                                >
                                    <b><i className="bi bi-person-circle" style={{ fontSize: '16px' }}></i></b>
                                </Link>
                                <button 
                                    className="btn btn-primary rounded-pill text-white py-2 px-4 flex-wrap flex-sm-shrink-0 ml-2 mt-1"
                                    onClick={(e) => { closeNavbars(e); handleLogout(e); }}
                                >
                                    <b><i className="bi bi-box-arrow-right" style={{ fontSize: '16px' }}></i></b>
                                </button>
                            </>
                            ) : (
                            <Link 
                                to="/login" 
                                className="btn btn-primary rounded-pill text-white py-2 px-4 flex-wrap flex-sm-shrink-0" 
                                onClick={(e) => { closeNavbars(e); }}
                            >
                                Login
                            </Link>
                        )}
                    </div>
                </nav>
            </div>
        </>
    );
}
